import { Component, OnInit } from '@angular/core';
import { DomSanitizer,SafeHtml } from '@angular/platform-browser';
import { BaseComponent } from '../../share/component/base.component';
import {ActivatedRoute} from '@angular/router';
import { FormsModule, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
declare var $;
declare var jslib;
@Component({
  selector: 'signCheck-component',
  templateUrl: './signCheck.component.html'
})
export class SignCheckComponent extends BaseComponent implements OnInit  {


  constructor(
    public _sanitizer: DomSanitizer,
    public router:ActivatedRoute
  ) {
    super();
  }
  public SelectedTime;
  public contacts;
  public user;
  public formSet;
  ngOnInit() {
    this.mainForm = new FormGroup({
      name: new FormControl('', [Validators.required, Validators.maxLength(10)]),
      englishName: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      email: new FormControl('', [Validators.required, Validators.maxLength(80)]),
      mobile : new FormControl('', [Validators.required,Validators.maxLength(10)]),
      tel: new FormControl('', [Validators.required,Validators.maxLength(30)])
    });

    var param = this.router.snapshot.params;
    ////console.log('param',this.router.snapshot.params);
    this.BuyerID = param['id'];
    this.GetEvent();
    var time = this.jslib.GetStorage('time');
    if(time){
      this.SelectedTime = time;
    }else{
      // this.route.navigateByUrl('/member/signTime/' + this.BuyerID);
    }

    //取得聯絡人
    this.baseApi.apiGet('v1/member/companyUser',{}).then((res)=>{
      this.contacts = res;

      var index = -1;
      var user = jslib.GetStorage('user');
      if(user){
        index = this.contacts.findIndex((ct)=>{return ct['account'] == user['account']});
      }
      if(index > -1){
        this.user = this.contacts[index];//預設使用者
      }else{
        this.user = this.contacts[0];//預設第一人
      }
      setTimeout(()=>{
        var _index = index < 0 ? 0 : index;
        $('#contactUser').val(_index);
      },250);
    });

    //20220825 調整 顯示公司名稱
    this.GetCompanyName();
  }

  SetUser(item){
    var _v = item.target.value;
    if(_v == 'add'){
      this.Edit();
      return false;
    }else{
      this.CancelEdit();
    }

    var index = Number(_v);
    var changeU = this.contacts[index];
    if(this.IsEdit){
      this.mainForm.reset(changeU);
    }
    console.log('user',changeU);
    //20220114調整規格 帶入公司資訊即可 欄位:公司網址,主要產品(中文),主要產品(英文)
    var p1 = $('#extra [name="company_url"]');
    var p2 = $('#extra [name="product"]');
    var p3 = $('#extra [name="product_en"]');
    if(p1 && changeU['url']){
      p1.val(changeU['url']);
    }
    if(p2 && changeU['product']){
      p2.val(changeU['product']);
    }
    if(p3 && changeU['productEn']){
      p3.val(changeU['productEn']);
    }
  }

  public formbase = {};
  FormSetHandler(set){
    this.formSet = [];
    //整理資料格式
    if(set){
      this.formSet = set;
      console.log('this.formSet',this.formSet);
      this.formbase = {};
      this.formSet.forEach(column => {
        this.formbase[column.id] = '';
      });
      //預帶資料
      setTimeout(()=>{
        console.log('user',this.user);
        //20220114調整規格 帶入公司資訊即可 欄位:公司網址,主要產品(中文),主要產品(英文)
        var p1 = $('#extra [name="company_url"]');
        var p2 = $('#extra [name="product"]');
        var p3 = $('#extra [name="product_en"]');
        if(p1 && this.user['url']){
          p1.val(this.user['url']);
        }
        if(p2 && this.user['product']){
          p2.val(this.user['product']);
        }
        if(p3 && this.user['productEn']){
          p3.val(this.user['productEn']);
        }
      });
    }
  };

  public BuyerID;
  public BData;
  public EventID = '';
  public EData;
  public DataReady = false;
  GetEvent(){
    this.DataReady = false;
    this.baseApi.apiGet('v1/buyer',{id:this.BuyerID}).then((res)=>{
      this.BData = res;
      this.EventID = res['event_id'];
      this.baseApi.apiGet('v1/event/' + this.EventID,{}).then((e_res)=>{
        this.EData = e_res;
        this.DataReady = true;
      });
      this.GetColumns();
    });
  }

  GetColumns(){
    //取得報名填寫表格
    this.baseApi.apiGet('v1/buyer/columns/' + this.EventID + '/' + this.BuyerID,{}).then((column_res)=>{
      ////console.log('formSet res',column_res);
      if(typeof column_res == 'string'){
        this.jslib.SetStorage('time',null);
        this.pop.setConfirm({
          content:column_res,
          event:()=>{
            this.route.navigateByUrl('/member/signTime/' + this.BuyerID);
          }
        });
      }else{
        // var test = [{"column_type":"textbox","maxCharacter":0,"number_only":false,"english_only":false,"id":"company_tel","name":"公司電話","required":true},{"column_type":"textbox","maxCharacter":0,"number_only":false,"english_only":false,"id":"company_fax","name":"公司傳真","required":true},{"column_type":"textarea","maxCharacter":500,"rows":4,"cols":40,"english_only":false,"id":"product","name":"主要產品(中文)","required":true},{"column_type":"textarea","maxCharacter":500,"rows":4,"cols":40,"english_only":false,"id":"product_en","name":"主要產品(英文)","required":true},{"column_type":"radiobox","options":[{"label":"台北","value":"TPE"},{"label":"台中","value":"TC"},{"label":"高雄","value":"KH"}],"required":true,"id":"video_location","name":"視訊地點","opt":[{"name":{"label":"台北","value":"TPE"},"value":"0"},{"name":{"label":"台中","value":"TC"},"value":"1"},{"name":{"label":"高雄","value":"KH"},"value":"2"}]},{"column_type":"checkbox","options":[{"label":"報名產品1","value":"1"},{"label":"報名產品2","value":"2"},{"label":"報名產品3","value":"3"}],"required":true,"id":"enroll_products","name":"報名產品"}];
        this.FormSetHandler(column_res);
      }
     });
  }

  public roleValid = false;//同意條款
  FormSubmit(){
    var extra = $('#extra').serializeObject();
    Object.assign(this.formbase,extra);
    //欄位驗證
    var keys = Object.keys(this.formbase);
    for(var i = 0; i < keys.length; i ++ ){
      var name = keys[i];
      var set = this.formSet.find((col)=>{return col['id'] == name});
      var isreq = set.required;
      var _v = extra[keys[i]];
      if(isreq && !_v){
        this.pop.setConfirm(set.name + '為必填');
        return false;
      }
    }


    //欄位驗證
    if(this.roleValid == false){
      this.pop.setConfirm('請勾選資料同意項目!');
      return false;
    }

    var base = {
      email: this.user.email,
      tel:this.user.tel,
      mobile:this.user.mobile,
      name:'',
      englishName:'',
      data:extra
    }
    if(typeof base.data['enroll_products'] == 'object'){
      base.data['enroll_products'] = base.data['enroll_products'].join();
    }

    var edit_idx = $('#contactUser').val();
    var edit_user:any = null;
    if(edit_idx == 'add'){
      var edit_user = this.mainForm.value;
    }else{
      var edit_user = this.contacts[(Number(edit_idx))];
    }

    base.email = edit_user.email;
    base.mobile = edit_user.mobile;
    base.tel = edit_user.tel;
    base.name = edit_user.name;
    base.englishName = edit_user.englishName;

    console.log('formBase',base);
    if(this.SelectedTime){
      this.baseApi.apiPost(
        'v1/buyer/enroll/' + this.EventID + '/' + this.SelectedTime.session_id + '?buyer_id=' + this.BuyerID + '&isisourcing=true'
      ,base).then((sign_res)=>{
        console.log('enroll Result',sign_res);
        this.jslib.SetStorage('signup',sign_res);
        this.jslib.SetStorage('time',null);
        this.route.navigateByUrl('/member/signSuccess');
       },(_err)=>{
         this.pop.setConfirm(_err['errorMessage']);
       });
    }else{
      this.baseApi.apiPost(
        'v1/buyer/enroll/' + this.EventID + '?buyer_id=' + this.BuyerID + '&isisourcing=true'
      ,base).then((sign_res)=>{
        console.log('enroll Result',sign_res);
        this.jslib.SetStorage('signup',sign_res);
        this.route.navigateByUrl('/member/signSuccess');
       },(_err)=>{
         this.pop.setConfirm(_err['errorMessage']);
       });
    }
  };

  CheckChecked(evt){
    this.ngzone.runOutsideAngular(()=>{
      var form = $('#extra').serializeObject();
      var dom = evt.target;
      var name = $(dom).attr('name');
      var _v = form[name];
      var set = this.formSet.find((col)=>{return col['id'] == name});
      //formSet寫死為
      var isreq = set.required;
      if(isreq &&  typeof _v == 'undefined'){
        $(dom).closest('.form-group').find('.help-block').css('display','block');
      }else{
        $(dom).closest('.form-group').find('.help-block').css('display','none');
      }
    });
  }

  CheckInput(evt){
    this.ngzone.runOutsideAngular(()=>{
      var dom = evt.target;
      var name = $(dom).attr('name');
      var _v = $(dom).val();
      var isreq = ($(dom).attr('required') == 'required');
      if(isreq && _v == ''){
        $(dom).closest('.form-group').find('.help-block').css('display','block');
      }else{
        $(dom).closest('.form-group').find('.help-block').css('display','none');
      }
    });
  }

  CheckTextArea(evt){
    this.ngzone.runOutsideAngular(()=>{
      var dom = evt.target;
      var name = $(dom).attr('name');
      var _v = $(dom).val();
      var _max = $(dom).attr('maxlength');
      var _c = $(dom).closest('.form-group').find('.count');
      _c.text(_v.length + '/' + _max);
      var isreq = ($(dom).attr('required') == 'required');
      if(isreq && _v == ''){
        $(dom).closest('.form-group').find('.help-block').css('display','block');
      }else{
        $(dom).closest('.form-group').find('.help-block').css('display','none');
      }
    });
  }

  public IsEdit = false;
  public mainForm: FormGroup;
  Edit(){
    this.mainForm.reset();
    this.IsEdit = true;
  }
  CancelEdit(){
    this.mainForm.reset(this.user);
    this.IsEdit = false;
  }
  ChangeTime(){
    this.jslib.SetStorage('time',null);
    this.route.navigateByUrl('/member/signTime/' + this.BuyerID);
  }

  public Company = '';
  GetCompanyName(){
    var u = jslib.GetStorage('user');
    if(u && u['company']){
      this.Company = u['company']['name'];
    }
  }
}
